import { ModelCategory, SnappingUnderlay } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const SnappingUnderlaySchema = new ModelSchema<SnappingUnderlay>('snappingUnderlay', {
  category: ModelCategory.IntermediateModel,

  pluralName: 'Snapping Underlays',
  displayName(underlay) {
    return underlay.name;
  },

  properties: {},
  children: {},
});
